import { css } from '@mui/system'
import { colors } from '../consts'

export const globalScrollbarStyles = css({
  // Webkit scrollbar styling
  '&::-webkit-scrollbar': {
    width: '8px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-track': {
    background: colors.offWhite,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: colors.gray.gray40,
    borderRadius: '4px',
    '&:hover': {
      background: colors.gray.gray60,
    },
  },

  // Firefox scrollbar styling
  scrollbarWidth: 'thin',
  scrollbarColor: `${colors.gray.gray40} ${colors.offWhite}`,
})

export const globalStyles = css({
  '*': {
    boxSizing: 'border-box',
  },
  body: {
    margin: 0,
    padding: 0,
  },
  '.scrollable': {
    ...globalScrollbarStyles,
  },
})
